<template>
  <SectionContentNumberedGuideCard v-bind="props" />
</template>

<script setup>
const props = defineProps({
  number: {
    type: String,
    default: '02'
  },
  eyebrow: {
    type: String,
    default: 'Next'
  },
  title: {
    type: String,
    default: 'Exercise & Movement'
  },
  theme: {
    type: String,
    default: 'brown'
  },
  introContent: {
    type: String,
    default: `<p>As we get older, many are tempted to sit more and move less. But frankly, that's the worst thing you can do for your body.</p>
<p>The risk of mortality increases by 20-30% when you spend a good portion of your day sitting.</p>`
  },
  splitCards: {
    type: Array,
    default: () => []
  },
  outroContent: {
    type: String,
    default: `<p>I mentioned walking and strength training throughout a few of the suggestions listed above, and these are great places to start.</p>
<p>Walk daily.</p>
<p>Strength train 3-4 times per week.</p>
<p>And, find something fun to do. Find some activity that brings you joy, and engage regularly.</p>`
  },
  quoteContent: {
    type: String,
    default: '<p>The remedy? Good, old-fashioned movement.</p>'
  },
  sideContent: {
    type: String,
    default: ''
  },
  imageSrc: {
    type: String,
    default: ''
  },
  imageAlt: {
    type: String,
    default: ''
  },
  tipsTitle: {
    type: String,
    default: ''
  },
  tipsContent: {
    type: String,
    default: ''
  },
  paddingTop: {
    type: String,
    default: 'reduced'
  },
  paddingBottom: {
    type: String,
    default: 'reduced'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Guide Exercise Movement',
  inputs: [
    {
      name: 'number',
      type: 'text',
      defaultValue: '02'
    },
    {
      name: 'eyebrow',
      type: 'text',
      defaultValue: 'Next'
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Exercise & Movement'
    },
    {
      name: 'theme',
      type: 'text',
      enum: ['green', 'brown', 'gold'],
      defaultValue: 'brown'
    },
    {
      name: 'introContent',
      type: 'richText',
      defaultValue: `<p>As we get older, many are tempted to sit more and move less. But frankly, that's the worst thing you can do for your body.</p>
<p>The risk of mortality increases by 20-30% when you spend a good portion of your day sitting.</p>`
    },
    {
      name: 'splitCards',
      type: 'list',
      defaultValue: [],
      subFields: [
        {
          name: 'value',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'text',
          type: 'longText',
          defaultValue: ''
        },
        {
          name: 'variant',
          type: 'text',
          enum: ['green', 'neutral'],
          defaultValue: 'green'
        }
      ]
    },
    {
      name: 'outroContent',
      type: 'richText',
      defaultValue: `<p>I mentioned walking and strength training throughout a few of the suggestions listed above, and these are great places to start.</p>
<p>Walk daily.</p>
<p>Strength train 3-4 times per week.</p>
<p>And, find something fun to do. Find some activity that brings you joy, and engage regularly.</p>`
    },
    {
      name: 'quoteContent',
      type: 'richText',
      defaultValue: '<p>The remedy? Good, old-fashioned movement.</p>'
    },
    {
      name: 'sideContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: ''
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tipsTitle',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tipsContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    }
  ]
})
</script>
